module.exports = __webpack_public_path__ + "static/assets/a51b949b03d40faa62ef202a787f76ec.png";